import React from 'react'
import FileIcon, { defaultStyles } from 'react-file-icon'

const getExtension = (filename) => {
  if (!filename || !filename.includes('.')) return ''
  return filename.split('.').pop().toLowerCase()
}

/**
 * File-type icon (react-file-icon) showing the extension label and
 * format-specific colors, e.g. PDF, DOCX, XLSX. Used across tendering,
 * doc-control and the public shared link page.
 *
 * @param {object} props
 * @param {string} [props.filename] - file name; its extension drives the icon
 * @param {number} [props.size=20] - icon size in px
 * @param {string} [props.className] - extra classes on the wrapper span
 * @param {string} [props.title] - tooltip
 * @param {(e: React.MouseEvent) => void} [props.onClick]
 */
export default ({ filename, size = 20, className = '', title, onClick }) => {
  const ext = getExtension(filename)

  return (
    <span
      className={['inline-flex', 'shrink-0', className].filter(Boolean).join(' ')}
      title={title}
      onClick={onClick}
    >
      <FileIcon extension={ext} {...(defaultStyles[ext] || {})} size={size} />
    </span>
  )
}
